"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionExistsModal = void 0;
const react_1 = __importStar(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const theme_ui_1 = require("theme-ui");
const billing_1 = require("../billing");
const react_2 = require("../common/react");
const SubscriptionExistsModal = () => {
    const [modalOpen, setModalOpen] = react_2.useLocalState("lastSubscriptionState", true);
    react_1.useEffect(() => {
        (async () => {
            const hasSubscription = await billing_1.currentUserHasValidSubscription();
            setModalOpen(!hasSubscription);
        })();
    });
    return react_1.default.createElement(react_modal_1.default, { isOpen: modalOpen, shouldCloseOnEsc: false, ariaHideApp: false, parentSelector: () => document.getElementById("subscription-modal-parent"), style: {
            overlay: {
                display: "flex",
            },
            content: {
                margin: "auto",
                position: "unset",
            },
        } },
        react_1.default.createElement(theme_ui_1.Box, null,
            react_1.default.createElement(theme_ui_1.Heading, { as: "h2" },
                "No subscription found. Please go to ",
                react_1.default.createElement(theme_ui_1.Link, { href: "https://roam.garden/app", target: "_blank" }, "Roam Garden"),
                " to set one up")));
};
exports.SubscriptionExistsModal = SubscriptionExistsModal;
//# sourceMappingURL=subscription-exists-modal.js.map